"use client";

import type { CreateAirdropFarmingBotRequest } from "@cede/types";
import { API_ENDPOINT, QueryKeys } from "@cede/utils";
import { useApi } from "@/hooks/core/useApi";
import { useHubUser } from "@/hooks/user/useHubUser";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";

export function useCreateBot() {
  const { auth } = useHubUser();
  const apiHelper = useApi();
  const queryClient = useQueryClient();

  const { mutate: createBot, isPending } = useMutation({
    mutationFn: async (request: CreateAirdropFarmingBotRequest) => {
      return apiHelper.postAuth(auth, API_ENDPOINT.HUB_AIRDROP_FARMING_BOTS, {
        bodyParams: request as Record<string, unknown>,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.AIRDROP_FARMING_BOTS] });
      enqueueSnackbar("Bot created successfully", { variant: "success" });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to create bot: ${error.message}`, { variant: "error" });
    },
  });

  return { createBot, isCreating: isPending };
}
